import { TokenData, TokenStorage } from '@app-velocity/request-gateway';

import {
  getFromLocalStorage,
  saveToLocalStorage,
  deleteFromLocalStorage,
} from '../core';

export class ClientTokenStorage implements TokenStorage {
  constructor(
    private accessTokenKey = 'accessToken',
    private refreshTokenKey = 'refreshToken'
  ) {}

  private async writeToken(
    tokenKey: string,
    token: string,
    expiresAt: number
  ): Promise<void> {
    const tokenData = JSON.stringify({
      token,
      expiresAt,
    });

    await saveToLocalStorage(tokenKey, tokenData);
  }

  private async readToken(tokenKey: string): Promise<TokenData | null> {
    const token = await getFromLocalStorage(tokenKey);

    if (!token) return null;

    return JSON.parse(token);
  }

  async readAccessToken(): Promise<TokenData | null> {
    return await this.readToken(this.accessTokenKey);
  }

  async writeAccessToken(token: string, expiresAt: number): Promise<void> {
    await this.writeToken(this.accessTokenKey, token, expiresAt);
  }

  async readRefreshToken(): Promise<TokenData | null> {
    return await this.readToken(this.refreshTokenKey);
  }

  async writeRefreshToken(token: string, expiresAt: number): Promise<void> {
    await this.writeToken(this.refreshTokenKey, token, expiresAt);
  }

  async clear(): Promise<void> {
    await deleteFromLocalStorage(this.accessTokenKey);
    await deleteFromLocalStorage(this.refreshTokenKey);
  }
}
